import React from 'react';
import Toast from '../../assets/Toast';
import CookieBanner from '../../components/CookieBanner';
import Icon from '../../components/Icon';

export default function ApprovalPendingScreen({ darkMode, publicLogo, onLogout }) {
  return (
    <div className={`app ${darkMode ? 'dark-mode' : ''}`}>
      <CookieBanner />
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 'var(--space-24)',
          background: darkMode
            ? 'linear-gradient(180deg, rgba(17,24,39,0.96), rgba(31,41,55,0.98))'
            : 'linear-gradient(180deg, #f8fffa, #eef7f0)',
        }}
      >
        <div
          style={{
            width: 'min(560px, 100%)',
            borderRadius: '22px',
            padding: 'var(--space-24)',
            background: darkMode ? 'rgba(17,24,39,0.92)' : 'var(--neutral-0)',
            border: darkMode ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(76,175,80,0.18)',
            boxShadow: '0 20px 50px rgba(0,0,0,0.12)',
            textAlign: 'left',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 'var(--space-16)', flexWrap: 'wrap' }}>
            <img src={publicLogo} alt="Krinkels" style={{ width: 72, height: 72, objectFit: 'contain' }} />
            <div>
              <div
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 'var(--space-8)',
                  padding: '6px 10px',
                  borderRadius: 999,
                  background: darkMode ? 'rgba(251,191,36,0.16)' : 'rgba(255,193,7,0.14)',
                  color: darkMode ? '#fde68a' : '#8a6200',
                  fontWeight: 700,
                  fontSize: 13,
                  marginBottom: 'var(--space-8)',
                }}
              >
                ⏳ Wachten op goedkeuring
              </div>
              <h2 style={{ margin: 0, color: 'var(--text-primary)' }}>Je account wordt gecontroleerd</h2>
            </div>
          </div>

          <p style={{ color: 'var(--text-secondary)', marginTop: 0, lineHeight: 1.6 }}>
            Je account is aangemaakt. Zodra een beheerder de toegang bevestigt, kun je automatisch verder in de app.
          </p>

          <div
            style={{
              display: 'grid',
              gap: 10,
              margin: '16px 0',
              padding: '14px var(--space-16)',
              borderRadius: 14,
              background: darkMode ? 'rgba(31,41,55,0.9)' : '#f7faf8',
              border: darkMode ? '1px solid rgba(255,255,255,0.06)' : '1px solid #e5efe7',
            }}
          >
            <div style={{ color: 'var(--text-primary)' }}><Icon name="check" size={16} /> Aanvraag ontvangen</div>
            <div style={{ color: 'var(--text-primary)' }}><Icon name="lock" size={16} /> Toegang wordt veilig gecontroleerd</div>
            <div style={{ color: 'var(--text-primary)' }}><Icon name="bolt" size={16} /> Na goedkeuring opent de app direct</div>
          </div>

          <div style={{ display: 'flex', gap: 'var(--space-12)', flexWrap: 'wrap' }}>
            <button className="control-btn" onClick={() => window.location.reload()}>
              Opnieuw controleren
            </button>
            <button className="control-btn logout-btn" onClick={onLogout}>
              Uitloggen
            </button>
          </div>
        </div>
      </div>
      <Toast />
    </div>
  );
}
